import React from 'react';
/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import axios from 'axios';
import { Table, Button, message, Input, Popconfirm } from 'antd';
// import components
import EditableTagGroup from '../components/SetRawFiles.AddMeta';
import UploadModal from '../components/SetRawFiles.Upload';

const EditableCell = ({editable, value, onChange})=>(
  <div style={{marginRight: '8px'}}>
    {
      editable
      ? <Input style={{margin: '-5px 0'}} 
          value={value} 
          onChange={e=>onChange(e.target.value)} />
      : value
    }
  </div>
);

/**
 * 
 * @param {array} fileList - input, simple array []
 * @param {array} newFileList - output, array [{key: "", name: "", experiment: ""}, {}]
 */
const setFilelist = (fileList) => {
  let newFileList = [];
  //clear data array for each function call
  for (let i = 0; i < fileList.length; i++) {
    //extract the file name from file extension
    let _fileList = [];
    let exp = "";
    _fileList = fileList[i].split('.');
    _fileList.pop();
    exp = _fileList.join("-");
    //push into data array
    newFileList.push({
      key: `${fileList[i]}`,
      name: `${fileList[i]}`,
      experiment: `${exp}`,
    });
  }
  return newFileList;
}

class SetRawFiles extends React.Component{
  constructor(props){
    super(props);

    this.state = {
      loading: false,
      rawfiles: [], // array of objects [{}, {}], for local state management
      selectedRawFiles: props.parameters.selectedRaw, // array of objects [{}, {}], for backend
      selectedRowKeys: props.parameters.raw, // simeple array ['', ''], for syncing UI
    };

    this.cacheData = this.state.rawfiles.map(item=>({...item}));
    this.columns = [
      {
        title: 'Name',
        dataIndex: 'name',
        width: '25%',
        // users should not modify the raw file names
        // render: (text, record)=>this.renderColumns(text, record, 'name'),
      }, 
      {
        title: "Meta Data",
        dataIndex: "metadata",
        width: '25%',
        render: (text, record)=>this.renderMetaColumn(text, record, 'metadata'),
      },
      {
        title: 'Experiment',
        dataIndex: 'experiment',
        width: '25%',
        render: (text, record)=>this.renderColumns(text, record, 'experiment'),
      },
      {
        title: 'Action',
        dataIndex: 'action',
        render: (text, record)=>{
          //console.log(record);
          const {editable} = record;
          return(
          <div>
          {
            editable 
            ? <span>
                <span 
                  css={css`
                    cursor: pointer;
                    color: steelblue;
                  `}
                  onClick={()=>this.save(record.key)}>Save</span>
                <Popconfirm 
                  title="Discard the changes?" 
                  onConfirm={()=>this.cancel(record.key)}>
                  <span css={css`
                    margin-left: 10px;
                    cursor: pointer;
                    color: steelblue;
                  `}>Cancel</span>
                </Popconfirm>
              </span>
            : <span 
                css={css`
                  cursor: pointer;
                  color: steelblue;
                `}
                onClick={()=>this.edit(record.key)}>Edit experiment
              </span>
          }
          </div>
          );
        },
      }
    ];
  }

  componentDidMount(){
    // console.log('raw file list component did mount');
    this.fetchFilelist(`${this.props.SERVER_APIS.SERVER_URL}${this.props.SERVER_APIS.FETCH_RAWFILELIST}`, this.props.sessID);
  }

  componentDidUpdate(prevProps, prevStates){
    // console.log('raw file list component did update');
    // console.log(prevProps);
    // console.log(prevStates);
  }

  ///////////////////////////////////////////////////////////////
  // cusmtomized column rendering
  ///////////////////////////////////////////////////////////////
  //
  // renderColumn() function is called by antd built-in function render()
  // with three arguments: text (built-in), record (built-in), 
  // and column name (custom, specifiies which column is being rendered)
  //
  // <EditableCell> is a react component take 3 arguments
  // editable, value, and onChange()
  //
  renderColumns(text, record, column){
    //
    // text: filename
    // record: {
    //    experiment: filename_without_filetype,
    //    key: filename,
    //    name: filename
    // }
    // column: 'experiment'
    //
    return(
      <EditableCell 
        editable={record.editable}
        value={text}
        onChange={value=>this.handleChange(value, record.key, column)}
      />
    );
  }

  renderMetaColumn(text, record, column){
    // console.log(record.key);
    let _list = this.state.selectedRawFiles.map(file=>file.meta);

    return(
      <EditableTagGroup 
        tagList = {_list}
        exp={record.key}
        column={column}
        updateMetaData={this.updateMetaData}
      />
    )
  }

  updateMetaData = (obj) => {
    // console.log(obj.exp);
    // console.log(obj.column);
    // console.log(obj.tags);

    let key = obj.exp;
    let column = obj.column;
    let list = [...obj.tags];


    let newData = JSON.parse(JSON.stringify(this.state.rawfiles));
    // console.log(newData);
    //
    // step 2
    // filter the selected file obj, target, from the file array, newData 
    // with now the key/value pair {editable: true} added already
    // this key/value pair is added when 'edit' is clicked
    // removed when 'save' or 'cancel' is clicked
    //
    const target = newData.filter(item=>key === item.key)[0];
    // console.log(target);
    //
    // step 3
    // target obj change made on {experiment: new value}
    // then setState rawfiles as newData
    //
    if(target){
      target[column] = list;
      this.setState({
        rawfiles: newData,
        selectedRowKeys: [],
        selectedRawFiles: [],
      });

      this.cacheData = newData.map(item=>({...item}));
    }
  }


  // ***
  // edit experiment names

  // ***
  // handle input value change at targeted table cell
  // which is determined by key and column
  //
  handleChange(value, key, column){
    //
    // step 1
    // make a local copy, newData, of this.state.rawfiles
    //
    const newData = [...this.state.rawfiles];
    //console.log(newData);
    //
    // step 2
    // filter the selected file obj, target, from the file array, newData 
    // with now the key/value pair {editable: true} added already
    // this key/value pair is added when 'edit' is clicked
    // removed when 'save' or 'cancel' is clicked
    //
    const target = newData.filter(item=>key === item.key)[0];
    //console.log(target);
    //
    // step 3
    // target obj change made on {experiment: new value}
    // then setState rawfiles as newData
    //
    if(target){
      target[column] = value;
      this.setState({rawfiles: newData});
    }
  }

  // enable editing
  edit(key){
    const newData = [...this.state.rawfiles];
    const target = newData.filter(item=>key === item.key)[0];
    if(target){
      target.editable = true;
      this.setState({rawfiles: newData});
    }
  }

  // save updates
  save(key){
    const newData = [...this.state.rawfiles];
    const target = newData.filter(item=>key === item.key)[0];
    if(target){
      delete target.editable; //remove editable key from target obj
      this.setState({
        rawfiles: newData,
        selectedRowKeys: [],
        selectedRawFiles: [],
      });
      this.cacheData = newData.map(item=>({...item}));
    }
  }

  // cancel updates
  cancel(key){
    const newData = [...this.state.rawfiles];
    const target = newData.filter(item=>key === item.key)[0];
    if(target){
      Object.assign(target, this.cacheData.filter(item=>key===item.key)[0]);
      delete target.editable;
      this.setState({rawfiles: newData});
    }
  }

  
  fetchFilelist = (url, sessID) => {
    // console.log(url);
    //need to reset selectedRowKeys for each xhttp-request
    this.setState({ 
      loading: true,
      selectedRowKeys: [],
      selectedRawFiles: [],
      rawfiles: [],
    });

    // *** axios POST request to PHP backend
    // ***
    // have to use FormData if you would like to use PHP super array $_POST
    let params = new FormData();
    params.append('sess_id', sessID);

    // ***
    // need to specify content-type for preflight check
    axios({
      url: url,
      method: 'post',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data: params,
    })
    .then(res => {
      // console.log(res);
      let _rawfiles = setFilelist(res.data);
      this.setState({
        rawfiles: _rawfiles,
        selectedRowKeys: this.props.parameters.raw,
        selectedRawFiles: this.props.parameters.selectedRaw,
        loading: false,
      });
      message.success('file list loaded successfully.');
    })
    .catch(err => {
      this.setState({loading: false});
      message.error('Connecting to iMetaLab server failed, unable to load files.');
    });
  }

  onSelectChange = (selectedRowKeys) => {
    // console.log('selectedRowKeys changed: ', selectedRowKeys);
    //syncronize selected row keys with rawfile list 
    let update_arr = [];
    for(let i = 0; i < selectedRowKeys.length; i++){
      for(let j = 0; j < this.state.rawfiles.length; j++){
        if(selectedRowKeys[i] === this.state.rawfiles[j].name){
          let obj = {};
          obj.name = this.state.rawfiles[j].name;
          obj.experiment = this.state.rawfiles[j].experiment;
          obj.metadata = this.state.rawfiles[j].metadata || [];
          update_arr.push(obj);
        }
      }
    }
    // console.log(update_arr);
    //update the selected ones
    this.setState({ 
      selectedRowKeys: selectedRowKeys,
      selectedRawFiles: update_arr, 
    });

    // ***
    // update parameters to parent
    let _parameters = JSON.parse(JSON.stringify(this.props.parameters));
    _parameters.selectedRaw = JSON.parse(JSON.stringify(update_arr));
    _parameters.raw = [...selectedRowKeys];
    this.props.updateParameters(_parameters);
  }
  
  render() {
    //update to parent, in this case, rawkeys are set the same as the file name
    // console.log('rendering...')
    // console.log(this.state);
    // console.log(this.props);
    
    const { sessID, userEmail, SERVER_APIS } = this.props;
    const { loading, selectedRowKeys, rawfiles } = this.state;

    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
    };
    const hasSelected = selectedRowKeys.length > 0;

    return (
    <div className="step-outter-wrapper">
      <div className="step-inner-wrapper">
        <div className="step-title-style">
          <h3>Select Files</h3>
        </div>

        <div className="rawfiles-content-wrapper">
          <div className="rawfiles-action-btns-wrapper">
            <UploadModal 
              sessID={sessID} 
              userEmail={userEmail}
              SERVER_APIS={SERVER_APIS}
              fetchFilelist={this.fetchFilelist}>
            </UploadModal>
            <Button 
              type="primary"
              icon="reload"
              onClick={()=>this.fetchFilelist(`${SERVER_APIS.SERVER_URL}${SERVER_APIS.FETCH_RAWFILELIST}`, sessID)}
              loading={loading}>
              Refresh list
            </Button>
          </div>
          
          <Table 
            bordered
            rowSelection={rowSelection} 
            columns={this.columns} 
            dataSource={rawfiles}/>
          
          <div style={{ marginLeft: 8 }}>
            <p>Uploaded {rawfiles.length} files (limit 10). Click <em>Refresh</em> button to update the list</p>
            {
              hasSelected 
              ? `Selected ${selectedRowKeys.length} out of ${rawfiles.length} files for submission` 
              : ''
            }
          </div>
        </div>
      </div>
    </div>
    );
  }
}

export default SetRawFiles;

SetRawFiles.defaultProps = {
  parameters: {
    raw: [],
    selectedRaw: []
  }
}
